"use strict";

// Copyright 2019-2020 The MathWorks, Inc.
define(['lit-element/lit-element.bundled'], function (litElementComponents) {
  'use strict'; // Since this is a decorator function, if we need to modify it for bug fixes.
  // We should be able to just return a different function with the modifications
  // before or after the call. No one should be looking at the prototype chain here.
  // since we are not a newable object.

  return litElementComponents.svg;
});
//# sourceMappingURL=svg.js.map
